var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.6001 10.423C9.67274 0.968695 15.9891 0.859674 18.5132 1.98695C19.6405 4.51105 19.5314 10.8274 10.0772 15.9C9.97912 15.3364 9.43386 13.8599 8.03704 12.4631C6.64022 11.0663 5.16374 10.521 4.6001 10.423Z",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3501 15.45C13.1886 16.35 13.3849 17.9638 13.6396 19.5C13.6396 19.5 17.4902 16.6535 15.0271 12.75",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.04996 9.22646C4.14996 7.38795 2.53615 7.19166 1 6.93697C1 6.93697 3.8465 3.08633 7.74997 5.54944",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.01808 13.411C3.50625 13.9228 2.63613 15.4072 3.25033 17.2498C5.09293 17.864 6.57725 16.9938 7.08909 16.482",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.3008 6.9502C15.3008 5.9837 14.5173 5.2002 13.5508 5.2002C12.5843 5.2002 11.8008 5.9837 11.8008 6.9502C11.8008 7.91669 12.5843 8.7002 13.5508 8.7002C14.5173 8.7002 15.3008 7.91669 15.3008 6.9502Z",
    stroke: "#5784F7",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon1);
export default __webpack_public_path__ + "static/media/LineIcon1.28ba23bd09fc1d4cd98193d1c87f2f77.svg";
export { ForwardRef as ReactComponent };